import type { PresetSuggestion } from '@/config/presets';

interface PresetStringsSuggestionsProps {
  presets: readonly PresetSuggestion[];
  onSelect: (value: string) => void;
  testIdPrefix: string;
}

export function PresetStringsSuggestions({ presets, onSelect, testIdPrefix }: PresetStringsSuggestionsProps) {
  if (presets.length === 0) {
    return null;
  }

  return (
    <div className="d-flex flex-wrap gap-1 mt-1" data-testid={`${testIdPrefix}-presets`}>
      {presets.map((preset) => (
        <button
          key={preset.value}
          type="button"
          className="btn btn-sm btn-outline-secondary me-1"
          data-testid={`${testIdPrefix}-preset-${preset.value}`}
          onClick={() => onSelect(preset.value)}
        >
          {preset.label ?? preset.value}
        </button>
      ))}
    </div>
  );
}
